import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=14f4a55d&scoped=true&"
import script from "./phoneLogin.vue?vue&type=script&lang=js&"
export * from "./phoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./phoneLogin.vue?vue&type=style&index=1&id=14f4a55d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f4a55d",
  null
  
)

export default component.exports